export default __webpack_public_path__ + "static/media/Todd Bonzalez.1aa08edf.jpg";